module.exports = __webpack_public_path__ + "static/fonts/BarlowSemiCondensed-Regular.903ba0f4.ttf";